import React, { useState, useEffect } from "react";
import Dialog from "@material-ui/core/Dialog";
import t from "../../../../helpers/t";
import { Biscuit } from "../../../../../utils";
import { $, moment } from "../../../../../../vendor";
import DatePicker from "react-datepicker";
import de from "date-fns/locale/de";
import fr from "date-fns/locale/fr";
import en from "date-fns/locale/en-GB";
import { showFile } from "../../../../../utils/Helper";
import { ordersActions, useSelector } from "inbooma-api";

const SDFDialog = (props) => {
  const { handleCloseDialog, dispatch, language, showNotification } = props;
  const [from, setFrom] = useState(
    moment(new Date()).subtract(1, "months").format("YYYY-MM-01 00:00:00"),
  );
  const [to, setTo] = useState(
    moment(new Date()).subtract(1, "months").endOf("month").format("YYYY-MM-DD HH:mm:ss"),
  );
  const _sdfExport = useSelector((state) => state.orders.exportSDF);
  const [submitting, setSubmitting] = useState(false);
  const [warning, setWarning] = useState(false);
  const [loading, setLoading] = useState(false);
  const getSDF = () => {
    let body = {
      from: from,
      to: to,
      client_id: Biscuit.get("client.id"),
    };
    console.log(body);
    dispatch(ordersActions.exportSDFResetData());
    dispatch(
      ordersActions.exportSDF({
        token: Biscuit.get("token"),
        data: body,
        parameters: {
          headers: {
            "Accept-Language": language,
            "Content-Language": language,
          },
        },
      }),
    );
    body = null;
    /*setSubmitting(!getDocHandler(
            '/orders/exportSDF',
            'POST',
            'application/zip',
            'export.zip',
            'export could not be downloaded',
            null,
            body,
            false,
            false,
            false,
            true));*/
  };

  function str2bytes(str) {
    let bytes = new Uint8Array(str.length);
    for (let i = 0; i < str.length; i++) {
      bytes[i] = str.charCodeAt(i);
    }
    return bytes;
  }

  useEffect(() => {
    if (_sdfExport.success === "" || !submitting) {
      return;
    }
    setSubmitting(false);
    if (_sdfExport.success === false) {
      let message = t("something went wrong");
      if (typeof _sdfExport.data.message === "string") {
        message = _sdfExport.data.message;
      }
      setWarning(message);
      showNotification("warning", null, message);
    } else {
      let blob = new Blob([str2bytes(atob(_sdfExport.data))], { type: "application/zip" });
      showFile(blob, "export.zip");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [_sdfExport]);

  useEffect(() => {
    console.log(to);
    setLoading(false);
  }, [from, to]);
  const onSubmit = () => {
    getSDF();
    setWarning(false);
    setSubmitting(true);
  };

  const onChangeField = (e, name) => {
    let date, time;
    switch (name) {
      case "from_date_field":
        date = moment(e).format("YYYY-MM-DD");
        time = moment(from).format("HH:mm:00");
        setFrom(moment(date + " " + time).format("YYYY-MM-DD HH:mm:00"));
        if (new Date(moment(date + " " + time).format("YYYY-MM-DD HH:mm:00")) > new Date(to)) {
          setTo(
            moment(new Date(moment(date + " " + time).format("YYYY-MM-DD HH:mm:00"))).format(
              "YYYY-MM-DD HH:mm:00",
            ),
          );
        }
        break;
      case "to_date_field":
        date = moment(e).format("YYYY-MM-DD");
        time = moment(to).format("HH:mm:00");
        setTo(moment(date + " " + time).format("YYYY-MM-DD HH:mm:00"));
        if (new Date(moment(date + " " + time).format("YYYY-MM-DD HH:mm:00")) < new Date(from)) {
          setFrom(
            moment(new Date(moment(date + " " + time).format("YYYY-MM-DD HH:mm:00"))).format(
              "YYYY-MM-DD HH:mm:00",
            ),
          );
        }
        break;
    }
    setLoading(true);
    $(".input-group-field").css("border-color", "rgb(227, 227, 227)");
  };

  return (
    <>
      <Dialog
        onClose={handleCloseDialog}
        aria-labelledby="sdf-dialog-title"
        open={true}
        name="sdfDialog"
        id="sdfDialog"
        maxWidth={"ld"}
        style={{ maxHeight: "300px" }}
      >
        <header className="inb-sdf-header">
          <button
            onClick={handleCloseDialog}
            type="button"
            id="inb-sdf-dialog-close-button"
            className="button hollow secondary right button-close-sdf-dialog round"
            title={t("close show status")}
          >
            <i className="fi fi-x"></i>
          </button>
          <h4>{t("export_sdf", null, "capital")}</h4>
        </header>

        <div
          id="inb-c-main-generate-sdf"
          className="inb-c-listing off-canvas-content"
          data-off-canvas-content=""
        >
          <div className="inb-c-item inb-c-item--from row" key="from">
            <div className="small-6 column">
              <div className="input-group inb-price-input-group">
                <div className="float-left">
                  <DatePicker
                    key={"inb-form-item-" + Math.floor(Math.random() * 10000)}
                    className="input-group-field"
                    dateFormat="dd. MMMM y"
                    selected={new Date(from)}
                    onChange={(date) => onChangeField(date, "from_date_field")}
                    onKeyDown={(e) => {
                      if (e.keyCode === 8) e.preventDefault();
                    }}
                    placeholderText=""
                    locale={
                      Biscuit.get("user.lang").indexOf("de") >= 0
                        ? de
                        : Biscuit.get("user.lang").indexOf("fr") >= 0
                          ? fr
                          : en
                    }
                  />
                </div>
                {/*  <input
                                    className="input-group-field"
                                    type="time"
                                    name="from_time_field"
                                    value={moment(new Date(from)).format('HH:mm') }
                                    style={{maxWidth: "40%"}}
                                    onChange={(e)=>{onChangeField(e,"from_time_field")}}
                                />*/}
              </div>
            </div>
            <div className="small-6 column">
              <div className="input-group inb-price-input-group">
                <div className="float-left">
                  <DatePicker
                    key={"inb-form-item-" + Math.floor(Math.random() * 10000)}
                    className="input-group-field"
                    dateFormat="dd. MMMM y"
                    selected={new Date(to)}
                    onChange={(date) => onChangeField(date, "to_date_field")}
                    onKeyDown={(e) => {
                      if (e.keyCode === 8) e.preventDefault();
                    }}
                    placeholderText=""
                    locale={
                      Biscuit.get("user.lang").indexOf("de") >= 0
                        ? de
                        : Biscuit.get("user.lang").indexOf("fr") >= 0
                          ? fr
                          : en
                    }
                  />
                </div>
                {/*<input
                                    className="input-group-field"
                                    type="time"
                                    name="to_time_field"
                                    value={moment(new Date(to)).format('HH:mm') }
                                    style={{maxWidth: "40%"}}
                                    onChange={(e)=>{onChangeField(e,"to_time_field")}}
                                />*/}
              </div>
            </div>
          </div>
          {warning && (
            <>
              <div className="inb-c-item inb-c-item-generate-sdf row" key="warning">
                <div
                  className="column medium-12 small-12"
                  style={{ textAlign: "center", color: "red" }}
                >
                  {warning}
                </div>
              </div>
            </>
          )}
          <div className="inb-c-item inb-c-item-generate-sdf row" key="generateSDF">
            <div className="column medium-3 small-4">&nbsp;</div>

            <div
              className="medium-6 small-10 column bnh"
              title={t("create", null, "capital")}
              style={{ minWidth: "90px", paddingTop: "8px" }}
            >
              {loading ? (
                <>
                  <span>
                    <img
                      alt="RollingLoader"
                      className="rollingLoader"
                      src={"assets/img/rolling_loader.svg"}
                    />{" "}
                    {t("create", null, "capital")}
                  </span>
                </>
              ) : (
                <>
                  <button>
                    <a
                      className={"button beautify beautify-" + Biscuit.get("user.client_id")}
                      href="#"
                      onClick={onSubmit}
                      style={{ minWidth: "180px" }}
                    >
                      <i className="fi fi-page-add"></i>
                      {submitting ? (
                        <>
                          <span>
                            <img
                              alt="RollingLoader"
                              className="rollingLoader"
                              src={"assets/img/rolling_loader.svg"}
                            />{" "}
                            {t("create", null, "capital")}
                          </span>
                        </>
                      ) : (
                        <span style={{ paddingLeft: "10px" }}>{t("create", null, "capital")}</span>
                      )}
                    </a>
                  </button>
                </>
              )}
            </div>
            <div className="column medium-3 small-1">&nbsp;</div>
          </div>
        </div>
      </Dialog>
    </>
  );
};

export default SDFDialog;
